import { CostRules, CostRulesModel } from "./cost-rules.model";

export interface ProductVersionsModel {
  costRules: Array<CostRulesModel>;
  description: string;
  gfhVersionNumber: number;
  id: string;
  minimumTradeAmount: number;
  minimumTradeAmountCurrency: string;
  productId: string;
  startDate: string;
  status: number;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class ProductVersions {
  costRules = new Array<CostRules>();
  description = "";
  gfhVersionNumber = -1;
  id = "";
  minimumTradeAmount = -1;
  minimumTradeAmountCurrency = "";
  productId = "";
  startDate = "";
  status = -1;
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: ProductVersionsModel) {
    if (!dto) {
      return;
    }
    this.costRules = dto.costRules;
    this.description = dto.description;
    this.gfhVersionNumber = dto.gfhVersionNumber;
    this.id = dto.id;
    this.minimumTradeAmount = dto.minimumTradeAmount;
    this.minimumTradeAmountCurrency = dto.minimumTradeAmountCurrency;
    this.productId = dto.productId;
    this.startDate = dto.startDate;
    this.status = dto.status;
    this.utcInsertDate = dto.utcInsertDate;
    this.utcUpdateDate = dto.utcUpdateDate;
    this.version = dto.version;
  }
}
